import React from 'react'
import type { ReactNode } from 'react'
import { Typography, type TypographyVariant, type TypographySizes } from '../../../index'

type BaseBodyProps<V extends TypographyVariant> = {
  children: ReactNode
  variant?: V
  size?: TypographySizes<V>
}

type BodyProps = {
  [V in TypographyVariant]: BaseBodyProps<V>
}[TypographyVariant]

function Body(props: BodyProps) {
  const { children, variant = 'caption', size = 'l' } = props

  return (
    <Typography {...({ variant, size, children } as Parameters<typeof Typography>[0])}>
      {children}
    </Typography>
  )
}

Body.displayName = 'MessageBox.Body'

export { Body }
